'use client'

import { connectDataConnectEmulator, getDataConnect, type DataConnect } from 'firebase/data-connect'
import { connectorConfig } from '@alumni/dataconnect-sdk'

import { app } from '@/firebase/config'

let dataConnectSingleton: DataConnect | null = null

/** Mapeo proyecto Firebase → serviceId de Data Connect. */
const SERVICE_BY_PROJECT: Record<string, string> = {
	'certificadossep-1f8c2': 'alumni-1f8c2-service',
	'certisepdev': 'alumni-dev-service'
}

/**
 * El SDK generado fija `service` en build-time (suele ser el de dev).
 * En prod hay que apuntar a `alumni-1f8c2-service` sin redeployar el YAML del cliente.
 */
function resolveDataConnectService(): string {
	const explicit = import.meta.env.VITE_DATACONNECT_SERVICE
	if (typeof explicit === 'string' && explicit.trim()) {
		return explicit.trim()
	}
	const projectId = import.meta.env.VITE_FIREBASE_PROJECT_ID
	if (typeof projectId === 'string' && SERVICE_BY_PROJECT[projectId]) {
		return SERVICE_BY_PROJECT[projectId]
	}
	return connectorConfig.service
}

/**
 * Cliente Data Connect para el conector alumni (misma app Firebase que Auth).
 * En Vite, variables `VITE_*` en `.env` — p. ej. `VITE_USE_DATACONNECT_EMULATOR=true` y levanta el emulador (puerto por defecto 9399).
 * Opcional: `VITE_DATACONNECT_SERVICE` para forzar el serviceId (prod: `alumni-1f8c2-service`).
 */
export function getAlumniDataConnect(): DataConnect {
	if (typeof globalThis.window === 'undefined') {
		throw new TypeError('Data Connect solo está disponible en el cliente')
	}
	if (!dataConnectSingleton) {
		const service = resolveDataConnectService()
		const dc = getDataConnect(app, { ...connectorConfig, service })
		if (import.meta.env.VITE_USE_DATACONNECT_EMULATOR === 'true') {
			const host = import.meta.env.VITE_DATACONNECT_EMULATOR_HOST ?? 'localhost'
			const port = Number(import.meta.env.VITE_DATACONNECT_EMULATOR_PORT ?? 9399)
			connectDataConnectEmulator(dc, host, port)
		}
		dataConnectSingleton = dc
	}
	return dataConnectSingleton
}
